import { Axios } from "../httpService";

export const ListTicket = () => {
  return Axios.get("/Ticket/ListTicket");
};

export const AddTicket = (data) => {
  return Axios.post("/Ticket/AddTicket", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const AddchatTicket = (data) => {
  return Axios.post("/Ticket/AddchatTicket", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const ListChatTicket = (id) => {
  return Axios.get(`/Ticket/ListChatTicket/${id}`);
};
